import NProgress from 'nprogress';
import { useEffect, useState, useRef } from 'react';
// routes
import { usePathname } from 'src/routes/hooks';
//
import StyledProgressBar from './styles';

// ----------------------------------------------------------------------

export default function ProgressBar() {
  const pathname = usePathname();
  const [mounted, setMounted] = useState(false);

  // Track previous pathname to detect actual navigation
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) {
      return undefined;
    }

    // Only show progress bar on actual navigation (pathname change)
    if (prevPathnameRef.current !== pathname) {
      NProgress.start();
      prevPathnameRef.current = pathname;
    }

    // Complete progress bar after a short delay (page has loaded)
    const timer = setTimeout(() => {
      NProgress.done();
    }, 100);

    return () => {
      clearTimeout(timer);
      NProgress.done();
    };
  }, [pathname, mounted]);

  if (!mounted) {
    return null;
  }

  return <StyledProgressBar />;
}
